import { render } from "./home-benefits.vue?vue&type=template&id=2dd1455c"
import script from "./home-benefits.vue?vue&type=script&lang=js"
export * from "./home-benefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__